// import dashboard from './dashboard';
import services from './services';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [services]
};

export default menuItems;
